var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTie = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 8 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5c6671",
  d: "M7.964.686A.502.502 0 007.5 0h-7a.501.501 0 00-.464.686l1.95 4.876L.005 19.43a.5.5 0 00.119.401l3.5 3.999a.498.498 0 00.752 0l3.5-4a.498.498 0 00.119-.402L6.014 5.563 7.964.687zM6.762 1l-1.6 4H2.839l-1.6-4h5.523zM4 22.741l-2.973-3.397L2.933 6.001h2.132l1.906 13.343-2.973 3.397z"
})));
export default SvgTie;